import { Carousel } from '@fancyapps/ui/dist/carousel';
import { Lazyload } from '@fancyapps/ui/dist/carousel/carousel.lazyload';
import { Arrows } from '@fancyapps/ui/dist/carousel/carousel.arrows';
import { Thumbs } from '@fancyapps/ui/dist/carousel/carousel.thumbs';
import { l10n } from '~/lib/ui/src/js/fancyapps';

const carouselOptions = {
  ...l10n[window.DOCUMENT_LANG]
    ? {
      l10n: l10n[window.DOCUMENT_LANG]
    }
    : {}
};

// formatCaption(ref: CarouselInstance, slide: CarouselSlide): HTMLElement | string
const formatCaption = (_ref, _slide) => {
  return '';
};

export default () => {
  apos.util.widgetPlayers.gallery = {
    selector: '[data-gallery-widget]',
    player: function (element) {
      let options = {};
      try {
        options = JSON.parse(element.dataset.galleryWidget || '{}');
      } catch (_err) {
        // console.error('Error parsing gallery widget options:', err);
      }
      Carousel(element, {
        ...carouselOptions,
        Thumbs: options.thumbs === 'none'
          ? false
          : {
            type: options.thumbs || 'classic'
          },
        transition: options.transition || 'fade',
        formatCaption
      }, {
        Lazyload,
        Arrows,
        Thumbs
      }).init();
    }
  };
};
